module.exports = {"body":"<p>TBA</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./_trips.md
// module id = 493
// module chunks = 0